import React from 'react';
import { useTranslation } from 'react-i18next'
import { CustomSelect } from '../../CustomControls/CustomSelect';

const SelectProtocol = ({ handleFilterChange, group }) => {
    const { t } = useTranslation();

    const handleChange = (name, value) => {

        if (value) {
            handleFilterChange(name, value.code)
        } else {
            handleFilterChange(name, null)
        }
    }

    const mapProtocolsToOptions = (groupsProtocols) => {
        return groupsProtocols.map(groupProtocol => ({
            code: groupProtocol.protocol.id,
            title: groupProtocol.protocol.title
        }));
    };
    const protocolOptions = mapProtocolsToOptions(group?.groupsProtocols)

    return (
        <CustomSelect
            name="protocolIds"
            placeholder={t("filters.protocol")}
            onChange={handleChange}
            isMulti={false}
            isClearable={true}
            options={protocolOptions}
        />

    );
};

export default SelectProtocol;
